import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { useUserStore } from './modules/user.js'
import useCounterStore from './modules/counter'
import useRouteCacheStore from './modules/routeCache'
import { useWebSocketStore } from './websocketStore'
import { usePathsStore } from './modules/paths.js'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export { useUserStore, useCounterStore, useRouteCacheStore, useWebSocketStore, usePathsStore }
export default pinia
